/* Helderbad: small, dependency-free UI helpers. */
(function () {
  'use strict';

  var TZ = 'Europe/Amsterdam';

  /* Offset (ms) of Europe/Amsterdam from UTC at a given instant, DST aware. */
  function tzOffset(ts) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).formatToParts(new Date(ts));
    var v = {};
    parts.forEach(function (p) { v[p.type] = p.value; });
    var asUtc = Date.UTC(+v.year, +v.month - 1, +v.day, +v.hour, +v.minute, +v.second);
    return asUtc - Math.floor(ts / 1000) * 1000;
  }

  /* "2026-10-14 23:59" as Amsterdam wall time -> UTC timestamp. Same instant for every visitor. */
  function parseEnd(value) {
    var m = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (!m) return NaN;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], 59);
    var utc = guess - tzOffset(guess);
    var corrected = guess - tzOffset(utc);
    return corrected;
  }

  /* Hide every wrapper marked data-hb-countdown-hide (e.g. the countdown and the whole launch bar). */
  function hideContainer(el) {
    var node = el;
    var box;
    while (node && (box = node.closest('[data-hb-countdown-hide]'))) {
      box.hidden = true;
      node = box.parentElement;
    }
  }

  if (!customElements.get('hb-countdown')) {
    customElements.define(
      'hb-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.end = parseEnd(this.dataset.end);
          if (isNaN(this.end)) return;
          this.units = {};
          ['d', 'h', 'm', 's'].forEach(
            function (u) { this.units[u] = this.querySelector('[data-unit="' + u + '"]'); }.bind(this)
          );
          this.tick();
          this.timer = setInterval(this.tick.bind(this), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          var left = this.end - Date.now();
          if (left <= 0) {
            clearInterval(this.timer);
            hideContainer(this);
            return;
          }
          var s = Math.floor(left / 1000);
          this.set('d', Math.floor(s / 86400));
          this.set('h', Math.floor((s % 86400) / 3600));
          this.set('m', Math.floor((s % 3600) / 60));
          this.set('s', s % 60);
        }

        set(unit, value) {
          var el = this.units[unit];
          if (!el) return;
          var text = unit === 'd' ? String(value) : String(value).padStart(2, '0');
          if (el.textContent === text) return;
          el.textContent = text;
          el.classList.remove('is-tick');
          void el.offsetWidth; /* restart the tick animation */
          el.classList.add('is-tick');
        }
      }
    );
  }

  /* Offer lines (e.g. "Koop 2, krijg 25% korting" under the cart button): hide after the end date. */
  document.querySelectorAll('[data-hb-offer-end]').forEach(function (el) {
    var end = parseEnd(el.dataset.hbOfferEnd);
    if (isNaN(end)) return;
    var hide = function () { el.hidden = true; };
    var left = end - Date.now();
    if (left <= 0) hide();
    else if (left < 2147483647) setTimeout(hide, left);
  });

  /* Launch bar: close button, remembered per offer end date. */
  document.querySelectorAll('[data-hb-launch]').forEach(function (bar) {
    var key = 'hb-launch-closed:' + (bar.dataset.end || '');
    try {
      if (localStorage.getItem(key) === '1') {
        bar.hidden = true;
        return;
      }
    } catch (e) {}
    var close = bar.querySelector('[data-hb-launch-close]');
    if (close) {
      close.addEventListener('click', function () {
        bar.hidden = true;
        try { localStorage.setItem(key, '1'); } catch (e) {}
      });
    }
  });

  /* Review strip: rotate up to 3 real review quotes taken from the Judge.me widget on the page. */
  var quoteEl = document.querySelector('[data-hb-quotes]');
  if (quoteEl) {
    var started = false;
    var collect = function () {
      if (started) return;
      var quotes = [];
      document.querySelectorAll('.jdgm-rev').forEach(function (rev) {
        if (quotes.length >= 3) return;
        var body = rev.querySelector('.jdgm-rev__body');
        var text = body ? body.textContent.replace(/\s+/g, ' ').trim() : '';
        if (text.length < 15) return;
        if (text.length > 110) text = text.slice(0, 107).replace(/\s+\S*$/, '') + '\u2026';
        var author = rev.querySelector('.jdgm-rev__author');
        quotes.push('\u201C' + text + '\u201D' + (author ? ' \u2014 ' + author.textContent.trim() : ''));
      });
      if (!quotes.length) return;
      started = true;
      var i = 0;
      quoteEl.textContent = quotes[0];
      quoteEl.hidden = false;
      if (quotes.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      setInterval(function () {
        quoteEl.classList.add('is-fading');
        setTimeout(function () {
          i = (i + 1) % quotes.length;
          quoteEl.textContent = quotes[i];
          quoteEl.classList.remove('is-fading');
        }, 400);
      }, 5000);
    };
    collect();
    if (!started && 'MutationObserver' in window) {
      var observer = new MutationObserver(collect);
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 20000);
    }
  }

  /* Image arrows (snippet helderbad-slider-nav): flip through a product's photos in place.
     Scrollable track (cards, mobile gallery): scroll-snap, arrows scroll, swipe is native.
     Non-scrolling gallery (product page / featured product on desktop): switch the active media
     through Dawn's media-gallery so the thumbnails stay in sync. */
  if (!customElements.get('hb-slider-nav')) {
    customElements.define(
      'hb-slider-nav',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.parentElement && this.parentElement.querySelector('[data-hb-track]');
          if (!this.track || this.started) return;
          this.started = true;
          this.gallery = this.closest('media-gallery');
          this.counter = this.querySelector('[data-hb-current]');
          this.dots = this.querySelectorAll('.hb-nav__dot');
          this.status = this.querySelector('[data-hb-status]');
          this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
          this.querySelector('[data-hb-prev]').addEventListener('click', this.step.bind(this, -1));
          this.querySelector('[data-hb-next]').addEventListener('click', this.step.bind(this, 1));
          this.addEventListener('keydown', this.onKey.bind(this));
          var queued = false;
          this.track.addEventListener('scroll', function () {
            if (queued) return;
            queued = true;
            requestAnimationFrame(function () { queued = false; this.update(); }.bind(this));
          }.bind(this), { passive: true });
          // Thumbnail clicks and variant changes move .is-active / reorder slides
          if ('MutationObserver' in window) {
            new MutationObserver(this.update.bind(this)).observe(this.track, {
              subtree: true, childList: true, attributes: true, attributeFilter: ['class']
            });
          }
          this.update();
        }

        slides() {
          return Array.prototype.filter.call(this.track.children, function (el) {
            return !el.hasAttribute('hidden');
          });
        }

        scrollable() {
          // Not scrollWidth alone: the slide-in animation briefly widens a non-scrolling gallery
          var overflow = getComputedStyle(this.track).overflowX;
          return (overflow === 'auto' || overflow === 'scroll') && this.track.scrollWidth > this.track.clientWidth + 2;
        }

        index() {
          var slides = this.slides();
          if (slides.length < 2) return 0;
          if (this.scrollable()) {
            var size = slides[1].offsetLeft - slides[0].offsetLeft || this.track.clientWidth;
            return Math.max(0, Math.min(slides.length - 1, Math.round(this.track.scrollLeft / size)));
          }
          var active = slides.findIndex(function (el) { return el.classList.contains('is-active'); });
          return active < 0 ? 0 : active;
        }

        step(dir, event) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }
          var slides = this.slides();
          var n = slides.length;
          if (n < 2) return;
          var i = (this.index() + dir + n) % n;
          if (this.scrollable()) {
            this.track.scrollTo({
              left: slides[i].offsetLeft - slides[0].offsetLeft,
              behavior: this.reduce.matches ? 'auto' : 'smooth'
            });
          } else if (this.gallery && this.gallery.setActiveMedia && slides[i].dataset.mediaId) {
            this.gallery.dataset.hbDir = dir > 0 ? 'next' : 'prev';
            this.gallery.classList.add('hb-animate');
            this.gallery.setActiveMedia(slides[i].dataset.mediaId, false);
          }
          if (this.status) this.status.textContent = (i + 1) + ' ' + (this.dataset.of || '/') + ' ' + n;
        }

        onKey(event) {
          if (event.key === 'ArrowLeft') this.step(-1, event);
          if (event.key === 'ArrowRight') this.step(1, event);
        }

        update() {
          var i = this.index();
          if (this.counter) this.counter.textContent = i + 1;
          for (var d = 0; d < this.dots.length; d++) this.dots[d].classList.toggle('is-active', d === i);
        }
      }
    );
  }

  /* Review badge and other in-page links: smooth scroll (CSS handles reduced motion). */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-hb-scroll]');
    if (!link) return;
    var target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
})();
